
import './App.css';
import Nav from './components/Nav/Nav';
import Students from './components/Students/Students';




function App() {
  return (
    <div className="App">
      
      <Students></Students>
    </div>
  );
}

export default App;
